import { render, staticRenderFns } from "./BuyPlan.vue?vue&type=template&id=32119204&"
import script from "./BuyPlan.vue?vue&type=script&lang=js&"
export * from "./BuyPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports